import axios from "axios";
import { Message } from "element-ui";
// eslint-disable-next-line no-undef
const jzbbaseurl = jzbhostname;

const service = axios.create({
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    Authorization: localStorage.getItem("token")
    // 'Authorization': 'a6HEqpDQyZrPL1ZlMBgPU11zL'
  }
});

// request interceptor 请求拦截
service.interceptors.request.use(
  config => {
    /* 请求头 */
    config.headers["Authorization"] = localStorage.getItem("token");
    //config.baseURL = jzbbaseurl
    if (config.method === "post") {
      config.data = JSON.stringify(config.data);
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log("请求错误", error); // for debug
    Promise.reject(error);
  }
);

// response interceptor 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      if (res.code !== 40101 && res.code !== 406) {
        Message({
          message: res.msg || res.message,
          type: "error"
        });
      }
    }
    return res;
  },
  error => {
    Message({
      message: error.message || error.msg,
      type: "error"
    });
    // console.log('jzb_api',error)
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/service/jzb_api.js